import {
  Component,
  Optional,
  Inject,
  Input,
  ViewChild,
  Injector,
} from '@angular/core';

import {
  NgModel,
  NG_VALUE_ACCESSOR,
  NG_VALIDATORS,
  NG_ASYNC_VALIDATORS,
} from '@angular/forms';

import {ElementBase, animations} from '../form';

@Component({
  selector: 'form-editor',
  template: `
  <div class="ui-input-container">
    <span class="md-inputfield">
      <p-editor
        [placeholder]="placeholder"
        [readonly]="readonly"
        [ngClass]="{'ng-invalid ui-state-filled': (invalid | async) && !disabled && dirty, 'ng-dirty': dirty}"
        [id]="identifier"
        [(ngModel)]="value"
        [style]="{'height':'220px'}"
        [disabled]="disabled" >
        <ng-content></ng-content>
        <p-header>
          <span class="ql-formats">
            <select class="ql-header">
              <option value="1">Heading 1</option>
              <option value="2">Heading 2</option>
              <option value="3">Heading 3</option>
              <option selected>Normal</option>
            </select>
            <select class="ql-font">
              <option selected>Sans Serif</option>
              <option value="serif">Serif</option>
              <option value="monospace">Monospace</option>
            </select>
          </span>
        <span class="ql-formats">
          <button class="ql-bold" aria-label="Bold"></button>
          <button class="ql-italic" aria-label="Italic"></button>
          <button class="ql-underline" aria-label="Underline"></button>
          <button class="ql-strike"></button>
        </span>
        <span class="ql-formats">
          <select class="ql-color"></select>
          <select class="ql-background"></select>
        </span>
        <span class="ql-formats">
          <button class="ql-list" value="ordered" aria-label="Ordered List"></button>
          <button class="ql-list" value="bullet" aria-label="Unordered List"></button>
          <select class="ql-align">
              <option selected></option>
              <option value="center"></option>
              <option value="right"></option>
              <option value="justify"></option>
          </select>
        </span>
        <span class="ql-formats">
          <button class="ql-link" aria-label="Insert Link" style="display:none"></button>
          <button class="ql-image" aria-label="Insert Image" style="display:none"></button>
          <button class="ql-code-block" aria-label="Insert Code Block" style="display:none"></button>
        </span>
        <span class="ql-formats">
          <button class="ql-clean" aria-label="Remove Styles"></button>
        </span> 
      </p-header>
    </p-editor>
      <label *ngIf="label" [attr.for]="identifier" style="top: -20px; font-size: 12px; color: #3F51B5;">{{label}}</label>
      <validation
        [@flyInOut]="'in,out'"
        *ngIf="(invalid | async) && !disabled && dirty"
        [messages]="failures | async">
      </validation>
    </span>
  </div>
  `,
  animations,
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: FormEditorComponent,
    multi: true,
  }]
})
export class FormEditorComponent extends ElementBase<string> {
  @Input() public placeholder: string = "";
  
  @Input() public disabled: boolean = false;
  @Input() public readonly: boolean = false;

  @ViewChild(NgModel) model: NgModel;

  public identifier = `form-editor-${identifier++}`;

  constructor(
    @Optional() @Inject(NG_VALIDATORS) validators: Array<any>,
    @Optional() @Inject(NG_ASYNC_VALIDATORS) asyncValidators: Array<any>,
    injector: Injector
  ) {
    super(validators, asyncValidators, injector);
  }
}

let identifier = 0;


// WEBPACK FOOTER //
// ./src/app/base/base-fields/components/editor.ts